"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.probabilityHasValueParameter = probabilityHasValueParameter;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
function probabilityHasValueParameter(value) {
    return (probability) => {
        return probability.parameters.some((p) => p.type === betweb_openapi_axios_1.ParameterType.Value && p.value === value);
    };
}
//# sourceMappingURL=probabilityHasValueParameter.js.map